<script setup>
import Modal from '../../Modal.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  onClose: { type: Function, default: () => {} },
  onConfirm: { type: Function, default: () => {} },
  title: { type: String, default: '' },
  message: { type: String, default: '' },
  messageValue: { type: String, default: '' },
  confirmText: { type: String, default: '' },
  rejectText: { type: String, default: '' },
  modalContainerClass: { type: String, default: '' },
  headerClass: { type: String, default: '' },
  actionsClass: { type: String, default: '' },
  // Aditivos e opcionais: o modal e compartilhado por muitas telas e nenhuma
  // delas passa estes dois, entao o comportamento antigo fica igual.
  disableConfirm: { type: Boolean, default: false },
});

const show = defineModel('show', { type: Boolean, default: false });
</script>

<template>
  <Modal
    v-model:show="show"
    :on-close="onClose"
    :container-class="modalContainerClass"
  >
    <woot-modal-header
      :class="headerClass"
      :header-title="title"
      :header-content="message"
      :header-content-value="messageValue"
    />
    <!-- Corpo opcional: quem precisa avisar o que sera destruido, ou pedir uma
         confirmacao digitada, coloca aqui. Sem slot, nada muda. -->
    <div v-if="$slots.default" class="px-8 pt-2">
      <slot />
    </div>
    <div class="flex items-center justify-end gap-2 p-8" :class="actionsClass">
      <Button faded slate type="reset" :label="rejectText" @click="onClose" />
      <Button
        ruby
        type="submit"
        :label="confirmText"
        :disabled="disableConfirm"
        @click="onConfirm"
      />
    </div>
  </Modal>
</template>
